module.exports = __webpack_public_path__ + "static/media/NeuzeitGroBold.5d633d6b.ttf";